import React, { useEffect } from 'react';
import './App.scss';
import {ForestCompositionProvider} from './ForestCompositionContext';
import ForestCompositionEditor from './ForestCompositionEditor';
import Matrix from './Matrix';
import ContentHeightSubject from './ContentHeightSubject';

const App = ({model}) => {
  const mounted = React.useRef(false);
  useEffect(() => {
    console.log('mounted',mounted);
    if (!mounted.current) {
      mounted.current = true;
    } else {
      // equivalent to componentDidUpate:  https://stackoverflow.com/questions/53255951/equivalent-to-componentdidupdate-using-react-hooks
      ContentHeightSubject.contentHeightDidChange();
    }
  });

  return (
    <div className="App m-3">
      <ForestCompositionProvider model={model}>
        <h4 className="mb-3">Forest Composition</h4>
        <ForestCompositionEditor allTrees={model.getTrees()}/>
        <h4 className="mb-3">Pest Vulnerability Matrix</h4>
        <Matrix refData={model.data}/>
      </ForestCompositionProvider>
    </div>
  );
};

export default App;